import { useState, useEffect } from 'react';
import { Portal } from './Portal';

interface InteractiveCampaignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  initialName?: string;
  title?: string;
}

export function InteractiveCampaignModal({
  isOpen,
  onClose,
  onSave,
  initialName = '',
  title = 'Nova Campanha Interativa',
}: InteractiveCampaignModalProps) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
    }
  }, [isOpen, initialName]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      return;
    }

    onSave(name);
    handleClose();
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Portal>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" onClick={handleClose} />

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl shadow-2xl w-full max-w-md relative z-10 overflow-hidden animate-scaleIn">
          {/* Header com gradiente */}
          <div className="relative px-8 py-6 bg-gradient-to-r from-blue-600/20 to-indigo-600/20 border-b border-white/10">
            <div className="absolute inset-0 bg-white/5 backdrop-blur-sm" />
            <h3 className="relative text-2xl font-bold text-white font-oswald tracking-wide">
              {title}
            </h3>
            <p className="relative text-gray-300 text-sm mt-1">
              Dê um nome para sua nova campanha
            </p>
          </div>

          <div className="p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Nome */}
              <div>
                <label className="block text-sm font-bold text-gray-300 mb-1.5 font-oswald tracking-wide uppercase">
                  Nome da Campanha
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Ex: Fluxo de Boas-vindas"
                  className="w-full px-4 py-3 bg-black/20 border border-white/10 rounded-xl focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all outline-none text-white font-medium placeholder-gray-500"
                  required
                  autoFocus
                />
                <p className="mt-2 text-xs text-blue-200 bg-blue-500/10 p-3 rounded-lg flex gap-2 border border-blue-500/20">
                  <span>💡</span>
                  Você configurará as conexões WhatsApp e categorias no nó Trigger após criar a campanha.
                </p>
              </div>

              {/* Ações */}
              <div className="flex gap-3 pt-2">
                <button
                  type="button"
                  onClick={handleClose}
                  className="flex-1 px-4 py-3 text-gray-300 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 hover:border-white/20 font-medium transition-all"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-3 text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl hover:shadow-lg hover:shadow-blue-500/30 font-bold font-oswald tracking-wide transition-all transform hover:-translate-y-0.5"
                >
                  SALVAR
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Portal>
  );
}
